export const RNRestart = {
  restart: () => {
    location.reload();
  },
  Restart: () => {
    location.reload();
  },
};
